import { createFileRoute } from '@tanstack/react-router';
import { EmployeesModule } from '@/modules/employees';

export const Route = createFileRoute('/(dashboard)/_dashboard/hr/employee')({
  component: EmployeesModule,
});
